// extracted by mini-css-extract-plugin
module.exports = {"container":"KtOrders_container__SsREI","header":"KtOrders_header__1kafd","textCenter":"KtOrders_textCenter__2hWLK","center":"KtOrders_center__3FC4j"};